<template>
    <nav class="relative" id="nav">
        <p class="main-bg text-white text-center uppercase">{{ announcement }}</p>
        <div class="container mx-auto">
            <div class="relative flex justify-between pb-20 px-5 pt-5 z-10">
                <router-link v-if="this.getSubdomain !== 'nta.' && this.getSubdomain !== 'sakura-' && this.getSubdomain !== 'elephanttour.' && this.getSubdomain !== 'gulliverusa.' && this.getSubdomain !== 'amnet.' && this.getSubdomain !== 'lighthouse.' && this.getSubdomain !== 'kddi.'" to="/" class="logo z-20 block md:hidden lg:block relative w-[200px]">
                    <img class="w-[111px]" src="@/assets/png/skygo-logo.png" alt="">
                </router-link>
                <router-link v-if="this.getSubdomain === 'nta.'" to="/" class="logo z-20 block md:hidden lg:block my-auto relative w-[200px]">
                    <img class="" src="@/assets/png/nta-logo-removebg-preview.png" alt="">
                </router-link>
                <router-link v-if="this.getSubdomain === 'sakura-'" to="/" class="logo z-20 block md:hidden lg:block my-auto relative w-[200px]">
                    <img src="@/assets/png/sakura_logo-removebg-preview.png" alt="">
                </router-link>
                <router-link v-if="this.getSubdomain === 'elephanttour.'" to="/" class="logo z-20 block md:hidden lg:block my-auto relative w-[200px]">
                    <img class="w-[111px]" src="@/assets/png/elephant-logo.svg" alt="">
                    <img class="absolute -z-10 -top-[85px] -left-10 w-full" src="@/assets/png/blue-cloud-logo.png" alt="">
                </router-link>
                <router-link v-if="this.getSubdomain === 'amnet.'" to="/" class="logo z-20 block md:hidden lg:block my-auto relative w-[200px]">
                    <img class="w-[111px]" src="@/assets/png/AMNET-LOGO-Official.svg" alt="">
                    <img class="absolute -z-10 -top-[80px] -left-10 w-full" src="@/assets/png/blue-cloud-logo.png" alt="">
                </router-link>
                <router-link v-if="this.getSubdomain === 'gulliverusa.'" to="/" class="logo z-20 block md:hidden lg:block my-auto relative w-[200px]">
                    <img class="w-[111px]" src="@/assets/png/NewGulliver.png" alt="">
                    <img class="absolute -z-10 -top-[80px] -left-10 w-full" src="@/assets/png/blue-cloud-logo.png" alt="">
                </router-link>
                <router-link v-if="this.getSubdomain === 'lighthouse.'" to="/" class="logo block md:hidden lg:block my-auto">
                    <img class="w-1/3 my-auto" src="@/assets/png/lighthouse-black.png" alt="">
                </router-link>
                <router-link v-if="this.getSubdomain === 'kddi.'" to="/" class="logo block md:hidden lg:block my-auto">
                    <img class="w-[130px] my-auto" src="@/assets/png/KDDI_logos.svg.png" alt="">
                </router-link>
                <div class="nav-items flex items-center gap-10">
                    <div class="md:flex justify-between items-center gap-4 hidden">
<!--                        <template v-if="!user || !user.id">-->
<!--                            <button-->
<!--                                class="btn pointer capitalize text-center flex items-center gap-4 main-bg  text-white  border-none py-3 px-9 rounded-3xl"-->
<!--                                @click="showLoginModal"-->
<!--                            >-->
<!--                                {{ $t('navbar.login') }}-->
<!--                            </button>-->
<!--                        </template>-->
<!--                        <template v-if="user && user.id">-->
<!--                            <button-->
<!--                                class="btn pointer capitalize text-center flex items-center gap-4  main-bg  text-white  border-none py-3 px-9 rounded-3xl"-->
<!--                                @click="logout"-->
<!--                            >-->
<!--                                Logout-->
<!--                            </button>-->
<!--                        </template>-->
                        <change-language-dropdown />
                    </div>
                </div>
                <div class="flex gap-6 lg:hidden block">
                    <change-language-dropdown class="md:hidden" />
                    <div class="space-y-2 block my-auto" @click="toggleBurger()">
                        <div class="w-8 h-1 rounded bg-white"></div>
                        <div class="w-8 h-1 rounded bg-white"></div>
                        <div class="w-8 h-1 rounded bg-white"></div>
                    </div>
                </div>
            </div>
        </div>
        <div

            class="fixed z-50 bg-white h-full top-0 w-full sm:w-1/2 flex flex-col justify-between p-4 transition-all lg:hidden"
            :class="burger ? 'left-0' : '-left-999'"
        >
            <ul class="flex gap-4 flex-col p-2 relative">
                <div class="my-auto md:hidden block absolute top-4 right-4" @click="toggleBurger()">
                    <img class="w-3 h-3" src="@/assets/png/x-mark.png" alt="">
                </div>
<!--                <li class="list-none flex justify-between">-->
<!--                    <router-link to="/plans" class="flex items-center no-underline gap-4 font-medium">-->
<!--                        <img src="@/assets/svg/wifi-icon.svg" alt="">-->
<!--                        Plans-->
<!--                    </router-link>-->
<!--                </li>-->
                <li class="list-none">
                    <router-link to="/" class="flex items-center no-underline gap-4 font-medium ml-4">
                        {{ $t("navbar_upd.homepage") }}
                    </router-link>
                </li>
                <li v-for="item in navbarEls" class="list-none">
                    {{ item.name }}
                    <router-link v-for="subItem in item.elements" :to="`${subItem.link}`" class="flex items-center no-underline gap-4 font-medium ml-4">
                        {{ subItem.title }}
                    </router-link>
                </li>
            </ul>
<!--            <div class="flex justify-between items-center gap-4 p-4">-->
<!--                <template v-if="!user || !user.id">-->
<!--                    &lt;!&ndash;            <router-link to="/login" class="btn pointer capitalize text-center flex items-center gap-4  main-bg  text-white  border-none py-2 px-9 rounded-3xl">&ndash;&gt;-->
<!--                    &lt;!&ndash;                Login&ndash;&gt;-->
<!--                    &lt;!&ndash;            </router-link>&ndash;&gt;-->

<!--                    <button-->
<!--                        class="btn pointer capitalize text-center flex items-center gap-4 main-bg  text-white  border-none py-2 px-9 rounded-3xl"-->
<!--                        @click="showLoginModal"-->
<!--                    >-->
<!--                        {{ $t('navbar.login') }}-->
<!--                    </button>-->
<!--                </template>-->
<!--                <template v-if="user && user.id">-->
<!--                    <button-->
<!--                        class="btn pointer capitalize text-center flex items-center gap-4 main-bg  text-white  border-none py-2 px-9 rounded-3xl"-->
<!--                        @click="logout"-->
<!--                    >-->
<!--                        Logout-->
<!--                    </button>-->
<!--                </template>-->
<!--            </div>-->
        </div>
    </nav>
    <div class="navbar hidden lg:block">
        <div class="container mx-auto">
            <div class="flex items-center justify-evenly">
                <router-link to="/" class="navbar__item flex items-center no-underline gap-4 font-medium ml-4">
                    {{ $t("navbar_upd.homepage") }}
                </router-link>
                <div
                    v-for="nav in navbarEls"
                    class="navbar__item"
                >
                    <div
                        class="flex items-center relative"
                        @mouseenter="showSubMenu(nav.id)"
                        @mouseleave="hideSubMenu"
                    >
                        <p
                            class="p-2 cursor-pointer"
                        >
                            {{nav.name}}
                        </p>
                        <div
                            v-if="showSubMenuId === nav.id"
                            class="navbar__item-menu"
                        >
                            <router-link v-for="navItems in nav.elements" :to="`${navItems.link}`" class="cursor-pointer">
                                 <component 
                                    :is="navItems.icon + '-icon'" 
                                    v-if="navItems.icon" 
                                    color="#35b8f5"
                                    width="24"
                                    height="24"
                                 />
                                {{navItems.title}}
                            </router-link>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChangeLanguageDropdown from "./ui/ChangeLanguageDropdown"
import MapIcon from "./ui/icons/map-icon.vue";
import PaymentIcon from "./ui/icons/payment-icon.vue";
import RouterIcon from "./ui/icons/router-icon.vue";
import FlightIcon from "./ui/icons/flight-icon.vue";
import LocationOnIcon from "./ui/icons/location-on-icon.vue";
import ShieldQuestionIcon from "./ui/icons/shield-question-icon.vue";
import SchoolIcon from "./ui/icons/school-icon.vue";
import ExploreIcon from "./ui/icons/explore-icon.vue";
import HandshakeIcon from "./ui/icons/handshake-icon.vue";
import CasesIcon from "./ui/icons/cases-icon.vue";
import HeadsetMicIcon from "./ui/icons/headset-mic-icon.vue";
import {mapGetters} from "vuex";
import {useI18n} from "vue-i18n/dist/vue-i18n";

export default {
    name: "Navbar",
    components: {
        ChangeLanguageDropdown,
        MapIcon,
        PaymentIcon,
        RouterIcon,
        FlightIcon,
        LocationOnIcon,
        ShieldQuestionIcon,
        SchoolIcon,
        ExploreIcon,
        HandshakeIcon,
        CasesIcon,
        HeadsetMicIcon,
    },

    data() {
        return {
            burger: false,
            announcement: '',
            showSubMenuId: null,
            navbarElsData: [
                {
                    id: 2, nameKey:  "navbar_upd.products_and_prices", elements: [
                        {id: 1, titleKey: 'navbar_upd.products_notes.coverage_map', icon: 'map', link: '/products-prices/map'},
                        {id: 2, titleKey: 'navbar_upd.products_notes.prices', icon: 'payment', link: '/purchase-rent'},
                        {id: 3, titleKey: 'navbar_upd.products_notes.device_info', icon: 'router', link: '/products-prices/device'},
                    ]
                },
                {
                    id: 3, nameKey: "navbar_upd.pickups_and_returns", elements: [
                        {id: 1, titleKey: 'navbar_upd.pickups_notes.how_to', icon: 'shield-question', link: '/pickups-returns/how-to'},
                        {id: 2, titleKey: 'navbar_upd.pickups_notes.airport', icon: 'flight', link: '/pickups-returns/airport'},
                        {id: 4, titleKey: 'navbar_upd.pickups_notes.more_locs', icon: 'location-on', link: '/pickups-returns/more-locations'},
                    ]
                },
                {
                    id: 4, nameKey: "navbar_upd.how_to_use", elements: [
                        {id: 1, titleKey: 'navbar_upd.how_to_use_notes.tutorial', icon: 'school', link: '/how-to-use/tutorial'},
                        {id: 2, titleKey: 'navbar_upd.how_to_use_notes.travel', icon: 'explore', link: '/how-to-use/travel'},
                        {id: 3, titleKey: 'navbar_upd.how_to_use_notes.business', icon: 'handshake', link: '/how-to-use/business'},
                        {id: 4, titleKey: 'navbar_upd.how_to_use_notes.more_cases', icon: 'cases', link: '/how-to-use/more'}
                    ]
                },
                {
                    id: 5, nameKey: "navbar_upd.contact", elements: [
                        {id: 1, titleKey: 'navbar_upd.contact_notes.customer_sup', icon: 'headset-mic', link: '/customersupport'},
                        {id: 2, titleKey: 'navbar_upd.contact_notes.for_business', icon: 'handshake', link: '/contact'},
                    ]
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            user: 'getUser',
        }),
        getSubdomain() {
            let siteUrl = window.location.hostname
            let regex = /^([a-z0-9]+)./gi
            let res = regex.exec(siteUrl)
            return res[0]
        },
        navbarEls() {
            return this.navbarElsData.map(item => ({
                ...item,
                name: this.$t(item.nameKey),
                elements: item.elements.map(element => ({
                    ...element,
                    title: this.$t(element.titleKey)
                }))
            }));
        }
    },
    created() {
        this.$axios.get('/navbar-announcement/get-one')
            .then((res) => {
                this.announcement = res.data.name
            })
    },

    methods: {
        showSubMenu(id) {
            const nav = this.navbarEls.find((item) => item.id === id);
            if (nav && nav.elements) {
                this.showSubMenuId = id;
            }
        },
        hideSubMenu() {
            this.showSubMenuId = null;
        },
        toggleBurger() {
            this.burger = !this.burger
        },

        logout() {
            this.$store.dispatch("logout");

            this.$toast.info('You have logged out successfully', {
                position: "bottom-left",
            });

            this.$store.dispatch('setAuthResultType', 'logout');
            this.$router.push({name: 'AuthResult'});
        },

        showLoginModal() {
            this.$store.dispatch('setAuthResultType', 'home');
            this.$router.push({name: 'Login'});
        }
    }
}
</script>

<style lang="scss">
nav {
    background-color: #35b8f5;

    &:before {
        content: '';
        background-image: url("../assets/png/header-after.png");
        background-size: cover;
        left: 50%;
        bottom: 0;
        width: 100%;
        height: 85px;
        transform: translateX(-50%);
        position: absolute;
    }

    a {
        font-family: 'Montserrat', sans-serif;
        font-weight: 500;
    }
}

.navbar {
    background-color: #35B8F5;
    border-top: 1px solid #35b8f5;
    border-bottom: 1px solid #35b8f5;
    padding: .25rem 0;

    &__item {
        color: #FFFFFF;
        margin-right: 1rem;
        font-family: 'Montserrat', sans-serif;
        font-weight: 500;
        font-size: 1.1rem;

        &-menu {
            position: absolute;
            z-index: 10;
            background-color: #EDFAFF;
            border-radius: 0.5rem;
            border: 1px solid #35b8f5;
            padding: .5rem 0;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            z-index: 10;
            top: 40px;
            width: 100%;
            width: 300px;

            a {
                color: #000000;
                width: 100%;
                display: flex;
                padding: .5rem 1rem;
                transition: all .1s ease-in-out;

                svg {
                    margin-right: .7rem;
                }

                &:hover {
                    background-color: #35b8f5;
                    color: #FFFFFF;

                    svg {
                        fill: #FFFFFF;
                    }
                }
            }
        }
    }
}

</style>